import { render, staticRenderFns } from "./territory.vue?vue&type=template&id=38391cea&scoped=true"
import script from "./territory.vue?vue&type=script&lang=js"
export * from "./territory.vue?vue&type=script&lang=js"
import style0 from "./territory.vue?vue&type=style&index=0&id=38391cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38391cea",
  null
  
)

export default component.exports